import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getCallLogs = async (start_date, end_date) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/call-logs/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          start_date,
          end_date,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Call log data fetch error:", error);
    throw error;
  }
};

export { getCallLogs };
